import { supabase } from "@/integrations/supabase/client";
import type { FunnelStepParams } from "@/types/analytics/logger-params";

interface SuiteVisitParams {
  userId: string;
  appName: string;
  appUrl: string;
  source: string;
  userAgent?: string;
  referrer?: string;
}

export class LoggerService {
  static async logSuiteVisit(params: SuiteVisitParams): Promise<void> {
    await supabase.functions.invoke("logger", {
      body: {
        action: "suite",
        data: params,
      },
    });
  }

  /**
   * Record one activation-funnel step.
   *
   * Same transport as `logSuiteVisit` on purpose: the `logger` edge function
   * authenticates any signed-in user and writes with the service-role client,
   * which is what makes it usable for ordinary customers. The `funnel` action
   * is specified in docs/handoff/time-to-value-instrumentation.md.
   */
  static async logFunnelStep(params: FunnelStepParams): Promise<void> {
    await supabase.functions.invoke("logger", {
      body: {
        action: "funnel",
        data: params,
      },
    });
  }

  static async logPageView(path: string): Promise<void> {
    await supabase.functions.invoke("logger", {
      body: {
        action: "page_view",
        data: { path },
      },
    });
  }
}
